import { FiltersRequestParameters } from "api/lokiRequestModels/FiltersRequestParameters";
import { services } from "api/serviceConfig";
import { dateEndFormatting, dateStartFormatting } from "helpers/dateFormatting";
import { productTypeStringDeFormatting, productTypeStringFormatting } from "helpers/productTypeStringFormatting";
import { makeAutoObservable, reaction, when } from "mobx";
import moment from "moment";
import React from "react";
import IdentityStore from "./IdentityStore";

export default class FiltersStore {
    identityStore: IdentityStore;

    module: "Lrm" | "Thor" | "Users" | "" = "";

    logisticsServiceProviders: string[] = [];
    selectedLogisticsServiceProviders: string[] = [];

    productTypes: string[] = [];
    selectedProductTypes: string[] = [];
    displayedProductTypes: string[] = [];
    displayedSelectedProductTypes: string[] = [];

    riskLevels: string[] = ["HEALTHY", "LOW", "MEDIUM", "HIGH"];
    selectRiskLevels: string[] = [];

    packagingTypes: string[] = [];
    selectedPackagingTypes: string[] = [];

    modesOfTransportation: string[] = [];
    selectedModesOfTransportation: string[] = [];

    startDate: Date = new Date(dateStartFormatting(new Date(moment().subtract(90, "d").format("YYYY-MM-DD HH:mm:ss"))));

    endDate: Date = new Date(dateEndFormatting(new Date(moment().format("YYYY-MM-DD HH:mm:ss"))));

    constructor(identityStore: IdentityStore) {
        makeAutoObservable(this);
        this.identityStore = identityStore;

        reaction(
            () => this.identityStore.currentCustomer,
            () => {
                if (this.module !== "Lrm") {
                    return;
                }

                this.startDate = new Date(moment().subtract(90, "d").format("YYYY-MM-DD HH:mm:ss"));
                this.endDate = new Date(moment().format("YYYY-MM-DD HH:mm:ss"));
                this.resetFilters();
            }
        );

        this.filtersAutoInvoke();
    }

    filtersAutoInvoke = () => {
        when(
            () => this.module === "Lrm" && !(!this.startDate || !this.endDate || !this.identityStore.currentCustomerId),
            () => {
                const request: FiltersRequestParameters = {
                    customerId: this.identityStore.currentCustomerId,
                    startTime: dateStartFormatting(this.startDate),
                    endTime: dateEndFormatting(this.endDate),
                };

                services.Filter.getLogisticsServiceProviders(request)
                    .then((response) => {
                        this.logisticsServiceProviders = response.data.logisticsServiceProviders;
                    })
                    .catch((error) => console.log(error));

                services.Filter.getPackagingTypes(request)
                    .then((response) => {
                        this.packagingTypes = response.data.packagingTypes;
                    })
                    .catch((error) => console.log(error));

                services.Filter.getModesOfTransportation(request)
                    .then((response) => {
                        this.modesOfTransportation = response.data.modesOfTransportation;
                    })
                    .catch((error) => console.log(error));

                services.Filter.getProductTypes(request)
                    .then((response) => {
                        this.displayedProductTypes = productTypeStringFormatting(response.data.productTypes);
                        this.productTypes = response.data.productTypes;
                    })
                    .catch((error) => console.log(error));
            }
        );
    };

    setModule = (module: "Lrm" | "Thor" | "Users" | "") => {
        this.module = module;
    };

    setSelectedLogisticsServiceProviders = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.selectedLogisticsServiceProviders = event.target.value as string[];
    };

    setSelectedRiskLevels = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.selectRiskLevels = event.target.value as string[];
    };

    setSelectedProductTypes = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.displayedSelectedProductTypes = event.target.value as string[];
        this.selectedProductTypes = productTypeStringDeFormatting(this.displayedSelectedProductTypes);
    };

    setSelectedPackagingTypes = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.selectedPackagingTypes = event.target.value as string[];
    };

    setSelectedModesOfTransportation = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.selectedModesOfTransportation = event.target.value as string[];
    };

    resetFilters = () => {
        this.selectedLogisticsServiceProviders = [];
        this.selectedProductTypes = [];
        this.displayedSelectedProductTypes = [];
        this.selectRiskLevels = [];
        this.selectedPackagingTypes = [];
        this.selectedModesOfTransportation = [];
    };

    setDateRange = (dateRange: Date[]) => {
        this.startDate = dateRange[0];
        this.endDate = dateRange[1];
        this.resetFilters();
    };
}
